import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Photo } from "@/components/Photo";
import { IMAGES } from "@/data/content";

/* The one "Get your free quote" band used at the foot of every page. `testId` keeps per-page test hooks. */
export const QuoteBand = ({ testId = "quote-band" }) => (
  <section className="bg-slate-50 border-t border-emerald-600/10" data-testid={testId}>
    <div className="grid lg:grid-cols-2">
      <Reveal className="order-2 lg:order-1">
        <Photo
          src={IMAGES.calmMoment}
          sizes="(max-width: 1024px) 100vw, 50vw"
          alt="A woman enjoying a quiet moment by a sunny bay window at home"
          loading="lazy"
          className="object-cover w-full h-64 sm:h-80 lg:h-full"
        />
      </Reveal>
      <div className="order-1 lg:order-2 flex items-center">
        <Reveal className="px-6 sm:px-12 lg:px-16 py-14 sm:py-20">
          <div className="flex items-center gap-4">
            <span className="w-10 h-px bg-rosegold-metallic" />
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-emerald-700">
              Ready for a cleaner, calmer home?
            </p>
          </div>
          <h2 className="font-accent text-4xl sm:text-5xl tracking-tight leading-[1.08] text-slate-900 mt-5">
            Get your free, no-obligation <span className="italic text-rosegold-deep">quote today.</span>
          </h2>
          <p className="text-base text-slate-600 leading-relaxed mt-6 max-w-md">
            Tell us a little about what you need and we'll get back to you with a tailored quote.
          </p>
          <Link to="/contact" data-testid={`${testId}-quote-btn`} className="btn btn-primary mt-8">
            Get Your Free Quote <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
